import { Banner } from 'component/banner';
import { HorizBox, Pad, PadBox, Separator } from 'component/basics';
import { ActionButton, Tag } from 'component/button';
import { Comment } from 'component/comment';
import { Heading, UtilityText } from 'component/text';
import { View } from 'react-native';
import { profileInterestsProperty } from 'structure/profile';
import { ArticleCard } from 'structure/question';
import { useCollection, useDatastore, useGlobalProperty } from 'util/datastore';
import { t } from 'util/stdtypes';

export const ProfileConversationRecommendationsFeature = {
    name: 'Profile Conversation Recommendations',
    key: 'profileconversationrecommendations',
    providesConfig: {
        profileWidgets: [ProfileConversationRecommendationWidget],
    },
};

export function ProfileConversationRecommendationWidget() {
    return <ProfileConversationRecommendationBox></ProfileConversationRecommendationBox>;
}

export function ProfileConversationRecommendationBox() {
    const myRecommendations = useCollection('commentrecommendation');

    const datastore = useDatastore();
    if (!myRecommendations || myRecommendations.length == 0) {
        return <></>;
    }
    return (
        <View>
            <Separator></Separator>
            <Pad></Pad>
            <Heading label={t('These conversations might interest you:')}></Heading>

            {myRecommendations.map((comment) => (
                <PadBox horiz={8} key={'recommended-comment-' + comment.commentKey} vert={8}>
                    <Banner color='lightgray'>
                        <ArticleCard article={comment.article} tags={comment.article.tags} thumbsize={64}></ArticleCard>
                        <Pad vert={4}></Pad>
                        <Comment commentKey={comment.commentKey}></Comment>
                        <MatchingTags tags={comment.tags}></MatchingTags>
                        <Pad vert={4}></Pad>
                        <HorizBox spread>
                            <ActionButton label={t('Jump to discussion')}></ActionButton>
                            <Pad vert={4}></Pad>
                            <ActionButton
                                label={t('Dismiss')}
                                onPress={() => datastore.deleteObject('commentrecommendation', comment.commentKey)}
                            ></ActionButton>
                        </HorizBox>
                    </Banner>
                </PadBox>
            ))}
        </View>
    );
}

export function MatchingTags({ tags }) {
    const myInterests = useGlobalProperty(profileInterestsProperty);
    if (!tags || !myInterests) return <></>;
    const matchingInterests = myInterests.filter((interest) => tags.includes(interest));

    if (matchingInterests.length > 0) {
        return (
            <HorizBox center>
                <UtilityText label={t('This conversation matches your interest in: ')}></UtilityText>
                <Tag color={'white'} label={matchingInterests[0]}></Tag>
            </HorizBox>
        );
    } else {
        return <></>;
    }
}
